const BrandMark = () => (
  <img
    className="brand-mark"
    src="https://cmj-site.nyc3.digitaloceanspaces.com/CMJS-IOS-2.png"
    alt=""
  />
);

export default BrandMark;
